module.exports = __webpack_public_path__ + "static/img/bq002.587d124.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/bq002.png
// module id = k8xH
// module chunks = 1